import * as React from 'react';
import { FC } from 'react';
import Redirect from 'components/Redirect';
import { useDispatch } from 'react-redux';
import { handleExternal } from 'store/appSlice';
import useActiveWorkspace from 'hooks/useActiveWorkspace';
// const token = useSelector((state: RootState) => state.token);
interface AuthGuardProps {
  children?: React.ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = ({ children }) => {
  const { activeWorkspace } = useActiveWorkspace();
  const dispatch = useDispatch();
  dispatch(handleExternal(false));

  if (activeWorkspace?.user?.access) {
    return <>{children}</>;
  } else {
    const workspaceUrl = sessionStorage.getItem('workspace-url');
    // check if workspace
    if (workspaceUrl) {
      window.location.replace(workspaceUrl + '/login');
    }
  }
  return <Redirect />;
};

export default AuthGuard;
